import React, { useContext, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import {
  TopNavContainer,
  NavGridContainer,
  GridItemContainer,
  AppLogo,
  MenuDrawer,
  TranslateOption,
  UserNameText,
  ListItem,
} from './styles';
import LogOutModal from '../../components/Modals/LogOutModal';
import { ENABLE_TOLGEE, ENTERPRISE_ENV, GO_CREATE_UI_DESIGN, IS_WHATSAPP_ENABLED, isFeatureEnabled } from '../../utils/helper';
import MultipleFileUploadModal from '../../components/Modals/MultipleFileUploadModal';
import { AppStoreContext } from '../../context/appStoreContext';
import { ChangePasswordModal } from '../../components/Modals';
import BillingPassword from '../../components/Modals/BillingPassword';
import { ENABLE_INSPIRATIONS, ENABLE_EMAIL_DESIGNS, EMAIL_REVAMP } from '../../utils/helper';
import Changelang from './Changelanguage';
import { removeDuplicateFirstNames } from '../../utils/javascript';
import { NAVIGATION_MENUS } from './translationValues';
import CustomTooltip from '../../components/CustomTooltip/CustomTooltip';
import { AppTourContext } from '../../context/appTourContext';
import SideNavButton from './SideNavButton';
import ChangelangTolgee from './ChangeLanguageTolgee';
import ImageWithFallback from '../../components/ImageWithFallback/ImageWithFallback';
import { DocStudioNavLogo } from '../../components/SidebarMenuIcons';
import { getTrackingAccessToken } from '../../utils/services/authAPI';
import { APP_VERSION } from '../../utils/helper';
import { signOutOrganization } from '../../utils/services/manageOrganizationAPI';
const NAMESPACES = ['NAVIGATION_MENUS'];

const SideNav = props => {
  const { t } = props;
  const { loginVisible, checkUserAccess, checkUserAccessRoles, userDetails, isEnterprise, setFetchingCategories, ssoSetup, licenseDetails, isOrganizationSignedIn, setIsOrganizationSignedIn } = useContext(AppStoreContext);
  const { tourSkipped } = useContext(AppTourContext);
  const [drawVisible, setDrawVisible] = useState(false);
  const [drawAnimate, setDrawAnimate] = useState(false);
  const [modalVisibility, setmodalVisibility] = useState(false);
  const [ModalVisibility, setModalVisibility] = useState(false);
  const [openPassword, setOpenPassword] = useState(false);
  const [subNavAnimate, setSubNavAnimate] = useState(true);
  const [subNav, setSubNav] = useState(false);
  const [showBillingModal, setShowBillingModal] = useState(false);
  const [subNavList, setSubNavList] = useState([]);
  const [userNameHover, setUserNameHover] = useState(false);

  const { displayName, firstName, lastName,planMapping } = userDetails;
  const userName = removeDuplicateFirstNames(displayName) || ((firstName || lastName) && `${firstName.trim()} ${lastName !== null ? lastName : ''}`);
  
  const showDraw = () => {
    setDrawVisible(true);
  };
  let history = useHistory();
  let currentLocation = useLocation();
  const hideDraw = () => {
    setSubNav(false);
    setDrawVisible(false);
    setDrawAnimate(true);
    setTimeout(() => {
      setDrawAnimate(false);
    }, 0); //1800
  };
  const redirectTo = e => {
    hideDraw();
    setTimeout(() => {
      if (e.includes('documentTemplates') || e.includes('shortMessageTemplates')) {
        if(e !== currentLocation.pathname)
        setFetchingCategories(true);
      }
      history.push(`${e}`);
    }, 1000);
  };

  const logOutUser = () => {
    hideDraw();
    setModalVisibility(true);
  };

  const togglePasswordModal = () => {
    hideDraw();
    setOpenPassword(true);
  };

  const exitOrganization = async () => {
    try {
      const response = await signOutOrganization();
      if(response.statusCode === 1930) {
        setIsOrganizationSignedIn(false);
        window.open('/', '_self')
      }
    } catch (err) {
      console.error(err)
    }
  }

  const navigateToWorkflow = async () => {
    const path = licenseDetails?.workFlowUrl;
    let redirectPath;
    if(!localStorage.getItem('sso_signIn')) {
      const response = await getTrackingAccessToken();
      if(response?.statusCode === 4002) {
        redirectPath = `${path}/pds-redirect?token=${response?.data}`;
      }
    } else {
      redirectPath = `${path}${ssoSetup?.ssoEnabled ? '/sso' : ''}`;
    }
    window.open(redirectPath, '_blank');
  };

  const accountDetailsSubNavList = [
      !isEnterprise &&
        checkUserAccessRoles(['ADMIN']) && {
          title: t(
            NAVIGATION_MENUS.BILLING_AND_INVOICE_MENU.key,
            NAVIGATION_MENUS.BILLING_AND_INVOICE_MENU.value,
          ),
          showBillingModal: true,
          desc: t(
            NAVIGATION_MENUS.BILLING_AND_INVOICE_MENU_DESCRIPTION.key,
            NAVIGATION_MENUS.BILLING_AND_INVOICE_MENU_DESCRIPTION.value,
          ),
        },
      !isEnterprise && {
        title: t(NAVIGATION_MENUS.USAGE_MENU_TITLE.key, NAVIGATION_MENUS.USAGE_MENU_TITLE.value),
        redirectTo: '/planUsage',
        desc: t(
          NAVIGATION_MENUS.USAGE_MENU_DESCRIPTION.key,
          NAVIGATION_MENUS.USAGE_MENU_DESCRIPTION.value,
        ),
      },
      checkUserAccessRoles(['ADMIN']) && {
        title: t(
          NAVIGATION_MENUS.INTEGRATION_KEY_MENU_TITLE.key,
          NAVIGATION_MENUS.INTEGRATION_KEY_MENU_TITLE.value,
        ),
        redirectTo: '/integrationKey',
        desc: t(
          NAVIGATION_MENUS.INTEGRATION_KEY_MENU_DESCRIPTION.key,
          NAVIGATION_MENUS.INTEGRATION_KEY_MENU_DESCRIPTION.value,
        ),
      },
    ].filter(v => !!v);

  return (
    <TopNavContainer>
      <MenuDrawer
        className={
          drawVisible
            ? !subNavAnimate
              ? 'drawVisible removeAnimation'
              : 'drawVisible'
            : drawAnimate
            ? 'drawAnimate'
            : 'drawInVisible'
        }
        onMouseLeave={() => setSubNav(false)}
      >
        <div className={!drawVisible ? 'switch' : 'switch_test'} />
        <div className="box">
          <div className="menus">
          <TranslateOption onMouseOver={() => setSubNav(false)}>
             {ENABLE_TOLGEE ? <ChangelangTolgee /> : <Changelang />} 
          </TranslateOption>
          {!loginVisible && (
            <>
              {GO_CREATE_UI_DESIGN && userName && (
                <div className="initial_avatar">
                  <span className="initial">{userName.charAt(0)}</span>
                  <span className="user_name">{userName}</span>
                </div>
              )}
              {!GO_CREATE_UI_DESIGN && userName && (
                <UserNameText
                drawVisible={drawVisible}
                onMouseOver={() => setUserNameHover(true)}
                onMouseLeave={() => setUserNameHover(false)}
                isHovered={userNameHover}>
                  <h2 className='full-name'>{userName}</h2>
                  <h2 className='initial'>{userName.charAt(0)}</h2>
                  <ul>
                    {Array.from({ length: 12 }, (_, index) => (
                      <ListItem key={index} drawVisible={drawVisible} isHovered={userNameHover} rotate={index*30}></ListItem>
                    ))}
                  </ul>
                </UserNameText>
              )}
                {/* {checkUserAccess('master', ['DESIGNER']) && (
                  <div
                    className="option"
                    onMouseOver={() => {
                      setSubNav(false);
                    }}
                    onClick={() => {
                      setmodalVisibility(true);
                    }}
                  >
                    {t(NAVIGATION_MENUS.ASSET_UPLOADS_MENU.key, NAVIGATION_MENUS.ASSET_UPLOADS_MENU.value)}
                    <div className="arrow" />
                  </div>
                )} */}
                {checkUserAccess('master', ['ADMIN']) && (
                  <div
                    className="option variables"
                    onMouseOver={() => {
                      setSubNav(true);
                      setSubNavAnimate(false);
                      setTimeout(() => {
                        setSubNavAnimate(true);
                      }, 20);
                      setSubNavList([
                      (!isOrganizationSignedIn && {
                        title: t(
                          NAVIGATION_MENUS.MANAGE_ORGANIZATIONS.key,
                          NAVIGATION_MENUS.MANAGE_ORGANIZATIONS.value,
                        ),
                        redirectTo: '/manageOrganizations',
                        desc: t(
                          NAVIGATION_MENUS.MANAGE_ORGANIZATIONS_MENU_DESCRIPTION.key,
                          NAVIGATION_MENUS.MANAGE_ORGANIZATIONS_MENU_DESCRIPTION.value,
                        ),
                      }),
                      (isOrganizationSignedIn && {
                        title: t(
                          NAVIGATION_MENUS.EXIT_ORGANIZATIONS.key,
                          NAVIGATION_MENUS.EXIT_ORGANIZATIONS.value,
                        ),
                        isOrganizationSignedIn,
                        desc: t(
                          NAVIGATION_MENUS.EXIT_ORGANIZATIONS_MENU_DESCRIPTION.key,
                          NAVIGATION_MENUS.EXIT_ORGANIZATIONS_MENU_DESCRIPTION.value,
                        ),
                      })
                    ]);
                    }}
                  >
                    {t(
                      NAVIGATION_MENUS.ORGANIZATIONS.key,
                      NAVIGATION_MENUS.ORGANIZATIONS.value,
                    )}
                  <div className="arrow" />
                </div>
              )}
                    {isFeatureEnabled('Dashboard', userDetails) && <div
                      className="option"
                      onMouseOver={() => {
                        setSubNav(true);
                        setSubNavAnimate(false);
                        setTimeout(() => {
                          setSubNavAnimate(true);
                        }, 20);
                        setSubNavList([
                          {
                            title: t(
                              NAVIGATION_MENUS.DOCUMENT_MENU_TITLE.key,
                              NAVIGATION_MENUS.DOCUMENT_MENU_TITLE.value,
                            ),
                            redirectTo: '/documentDashboard',
                            desc: t(
                              NAVIGATION_MENUS.DOCUMENT_DASHBOARD_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.DOCUMENT_DASHBOARD_MENU_DESCRIPTION.value,
                            ),
                          },
                          ENABLE_EMAIL_DESIGNS && {
                            title: t(
                              NAVIGATION_MENUS.EMAIL_MENU_TITLE.key,
                              NAVIGATION_MENUS.EMAIL_MENU_TITLE.value,
                            ),
                            redirectTo: EMAIL_REVAMP ? '/complexEmailDashboard' : '/emailDashboard',
                            desc: t(
                              NAVIGATION_MENUS.EMAIL_DASHBOARD_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.EMAIL_DASHBOARD_MENU_DESCRIPTION.value,
                            ),
                          },
                          isEnterprise && {
                            title: t(
                              NAVIGATION_MENUS.SHORT_MESSAGE_MENU_TITLE.key,
                              NAVIGATION_MENUS.SHORT_MESSAGE_MENU_TITLE.value,
                            ),
                            redirectTo: '/shortMessageDashboard',
                            desc: t(
                              NAVIGATION_MENUS.SHORT_MESSAGE_DASHBOARD_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.SHORT_MESSAGE_DASHBOARD_MENU_DESCRIPTION.value,
                            ),
                          },
                        ]);
                      }}
                    >
                      {t(NAVIGATION_MENUS.DASHBOARD_MENU.key, NAVIGATION_MENUS.DASHBOARD_MENU.value)}
                      <div className="arrow" />
                    </div>}
                {isFeatureEnabled('Design System', userDetails) && checkUserAccessRoles(['DESIGNER', 'PUBLISHER', 'EDITOR', 'REUSABLECONTENTMANAGER']) && (
                    <div
                      className="option"
                      onMouseOver={() => {
                        setSubNav(true);
                        setSubNavAnimate(false);
                        setTimeout(() => {
                          setSubNavAnimate(true);
                        }, 20);
                        setSubNavList([
                          ENABLE_INSPIRATIONS && {
                            title: t(
                              NAVIGATION_MENUS.DESIGN_INSPIRATION_MENU_TITLE.key,
                              NAVIGATION_MENUS.DESIGN_INSPIRATION_MENU_TITLE.value,
                            ),
                            redirectTo: '/designInspirations',
                            desc: t(
                              NAVIGATION_MENUS.DESIGN_INSPIRATION_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.DESIGN_INSPIRATION_MENU_DESCRIPTION.value,
                            ),
                          },
                          {
                            title: t(
                              NAVIGATION_MENUS.DOCUMENT_MENU_TITLE.key,
                              NAVIGATION_MENUS.DOCUMENT_MENU_TITLE.value,
                            ),
                            redirectTo: '/documentTemplates',
                            desc: t(
                              NAVIGATION_MENUS.DOCUMENT_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.DOCUMENT_MENU_DESCRIPTION.value,
                            ),
                          },
                          ENABLE_EMAIL_DESIGNS && {
                            title: t(
                              NAVIGATION_MENUS.EMAIL_MENU_TITLE.key,
                              NAVIGATION_MENUS.EMAIL_MENU_TITLE.value,
                            ),
                            redirectTo: EMAIL_REVAMP ? '/complexEmailTemplates' : '/emailTemplates',
                            desc: t(
                              NAVIGATION_MENUS.EMAIL_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.EMAIL_MENU_DESCRIPTION.value,
                            ),
                          },
                          isEnterprise && checkUserAccessRoles(['DESIGNER', 'PUBLISHER']) && {
                            title: t(
                              NAVIGATION_MENUS.SHORT_MESSAGE_MENU_TITLE.key,
                              NAVIGATION_MENUS.SHORT_MESSAGE_MENU_TITLE.value,
                            ),
                            redirectTo: '/shortMessageTemplates',
                            desc: IS_WHATSAPP_ENABLED ? t(
                              NAVIGATION_MENUS.SHORT_MESSAGE_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.SHORT_MESSAGE_MENU_DESCRIPTION.value,
                            ) : t(
                              NAVIGATION_MENUS.SHORT_MESSAGE_MENU_DESCRIPTION_WHATSAPP_DISABLED.key,
                              NAVIGATION_MENUS.SHORT_MESSAGE_MENU_DESCRIPTION_WHATSAPP_DISABLED.value,
                            ),
                          },
                          (isEnterprise && checkUserAccessRoles(['EDITOR'])) && {
                            title: t(
                              NAVIGATION_MENUS.INTERACTIVE_DOCUMENTS_MENU_TITLE.key,
                              NAVIGATION_MENUS.INTERACTIVE_DOCUMENTS_MENU_TITLE.value,
                            ),
                            redirectTo: '/interactiveTemplates',
                            desc: t(
                              NAVIGATION_MENUS.INTERACTIVE_DOCUMENTS_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.INTERACTIVE_DOCUMENTS_MENU_DESCRIPTION.value,
                            ),
                          }
                        ]);
                      }}
                    >
                      {t(
                        NAVIGATION_MENUS.DESIGN_SYSTEM_MENU_TITLE.key,
                        NAVIGATION_MENUS.DESIGN_SYSTEM_MENU_TITLE.value,
                      )}
                      <div className="arrow" />
                    </div>
                  )}
                {isFeatureEnabled('Transactions', userDetails) && checkUserAccessRoles(['ADMIN', 'DESIGNER', 'PUBLISHER', 'JOBMANAGER', 'JOBAPPROVERL1', 'JOBAPPROVERL2', 'JOBAPPROVERL3', 'JOBAPPROVERL4']) && (
                    <div
                      className="option"
                      onMouseOver={() => {
                        setSubNav(true);
                        setSubNavAnimate(false);
                        setTimeout(() => {
                          setSubNavAnimate(true);
                        }, 20);
                        const subNavList = [
                           checkUserAccessRoles(['ADMIN', 'DESIGNER', 'PUBLISHER', 'JOBMANAGER', 'JOBAPPROVERL1', 'JOBAPPROVERL2', 'JOBAPPROVERL3', 'JOBAPPROVERL4']) && {
                            title: t(
                              NAVIGATION_MENUS.SMART_BATCH_STUDIO_TITLE.key, 
                              NAVIGATION_MENUS.SMART_BATCH_STUDIO_TITLE.value
                            ),
                            desc: t(
                              NAVIGATION_MENUS.SMART_BATCH_STUDIO_DESC.key, 
                              NAVIGATION_MENUS.SMART_BATCH_STUDIO_DESC.value
                            ),
                            redirectTo: '/statusMonitoring',
                          },
                          // {
                          //   title: t(
                          //     NAVIGATION_MENUS.GENERATE_PDF_MENU_TITLE.key,
                          //     NAVIGATION_MENUS.GENERATE_PDF_MENU_TITLE.value,
                          //   ),
                          //   redirectTo: '/publishedTemplates',
                          //   desc: t(
                          //     NAVIGATION_MENUS.GENERATE_PDF_MENU_DESCRIPTION.key,
                          //     NAVIGATION_MENUS.GENERATE_PDF_MENU_DESCRIPTION.value,
                          //   ),
                          // },
                          // ENABLE_EMAIL_DESIGNS && {
                          //   title: t(
                          //     NAVIGATION_MENUS.TRIGGER_EMAIL_MENU_TITLE.key,
                          //     NAVIGATION_MENUS.TRIGGER_EMAIL_MENU_TITLE.value,
                          //   ),
                          //   redirectTo: EMAIL_REVAMP ? '/complexEmailPublishedTemplates' : '/emailPublishedTemplates',
                          //   desc: t(
                          //     NAVIGATION_MENUS.TRIGGER_EMAIL_MENU_DESCRIPTION.key,
                          //     NAVIGATION_MENUS.TRIGGER_EMAIL_MENU_DESCRIPTION.value,
                          //   ),
                          // },
                          IS_WHATSAPP_ENABLED && isEnterprise && checkUserAccessRoles(['DESIGNER', 'PUBLISHER']) && {
                            title: t(
                              NAVIGATION_MENUS.SEND_WHATSAPP_MENU_TITLE.key,
                              NAVIGATION_MENUS.SEND_WHATSAPP_MENU_TITLE.value,
                            ),
                            redirectTo: '/publishedMessages',
                            desc: t(
                              NAVIGATION_MENUS.SEND_WHATSAPP_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.SEND_WHATSAPP_MENU_DESCRIPTION.value,
                            ),
                          },
                          isEnterprise && checkUserAccessRoles(['DESIGNER', 'PUBLISHER']) && {
                            title: t(
                              NAVIGATION_MENUS.SEND_SMS_MENU_TITLE.key,
                              NAVIGATION_MENUS.SEND_SMS_MENU_TITLE.value,
                            ),
                            redirectTo: '/publishedSMS',
                            desc: t(
                              NAVIGATION_MENUS.SEND_SMS_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.SEND_SMS_MENU_DESCRIPTION.value,
                            ),
                          },
                          isEnterprise && checkUserAccessRoles(['DESIGNER', 'PUBLISHER']) && {
                            title: t(
                              NAVIGATION_MENUS.INITIATE_CALL_MENU_TITLE.key,
                              NAVIGATION_MENUS.INITIATE_CALL_MENU_TITLE.value,
                            ),
                            redirectTo: '/publishedCallMessages',
                            desc: t(
                              NAVIGATION_MENUS.INITIATE_CALL_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.INITIATE_CALL_MENU_DESCRIPTION.value,
                            ),
                          },
                        ];
                        let allSubNavs = [];
                        if (ENTERPRISE_ENV && checkUserAccessRoles(['FORMUSER'])) {
                          const generateFormSubNav = {
                            title: 'Generate Form',
                            redirectTo: '/generateForms',
                            desc: 'Generate transactions using forms',
                          };
                          allSubNavs.push(generateFormSubNav);
                        }
                        if (checkUserAccessRoles(['DESIGNER', 'PUBLISHER'])) {
                          allSubNavs = [...allSubNavs, ...subNavList];
                        }
                        setSubNavList(subNavList); // To add PDS forms, set allSubNavs here
                      }}
                    >
                      {t(NAVIGATION_MENUS.TRANSACTIONS_MENU.key, NAVIGATION_MENUS.TRANSACTIONS_MENU.value)}
                      <div className="arrow" />
                    </div>
                  )}
               {isFeatureEnabled('Admin Configurations', userDetails) && checkUserAccessRoles(['ADMIN', 'MAILROOMADMIN']) && (
                <div
                  className="option settings"
                  onMouseOver={() => {
                    setSubNav(false);
                  }}
                  onClick={() => redirectTo('/user/account-settings')}
                >
                  {t(NAVIGATION_MENUS.ADMIN_CONFIGURATION_MENU.key, NAVIGATION_MENUS.ADMIN_CONFIGURATION_MENU.value)}
                  <div className="arrow" />
                </div>
              )}
              {/* {isFeatureEnabled('Hybrid Mail Room', userDetails) && (ENTERPRISE_ENV && checkUserAccessRoles(['HYBRID'])) && (
                <div
                  className="option settings"
                  onMouseOver={() => {
                    setSubNav(false);
                  }}
                  onClick={() => redirectTo('/hybridMail')}
                >
                  {t(NAVIGATION_MENUS.HYBRID_MAIL_ROOM_MENU.key, NAVIGATION_MENUS.HYBRID_MAIL_ROOM_MENU.value)}
                  <div className="arrow" />
                </div>
              )} */}
                {isFeatureEnabled('Account Details', userDetails) && accountDetailsSubNavList.length > 0 ? <div
                   className="option settings"
                  onMouseOver={() => {
                    setSubNav(true);
                    setSubNavAnimate(false);
                    setTimeout(() => {
                      setSubNavAnimate(true);
                    }, 20);
                    setSubNavList(accountDetailsSubNavList);
                  }}
                >
                  {t(NAVIGATION_MENUS.ACCOUNT_DETAILS_MENU_TITLE.key, NAVIGATION_MENUS.ACCOUNT_DETAILS_MENU_TITLE.value)}                   
                  <div className="arrow" />
                </div> : null}
              {isFeatureEnabled('Mail Room', userDetails) && isEnterprise && checkUserAccessRoles(['MAILROOMADMIN', 'MAILROOMCLIENT']) && (
                  <div
                    className="option"
                    onMouseOver={() => {
                      setSubNav(false);
                    }}
                    onClick={() => redirectTo('/mailRoom')}
                  >
                    {t(NAVIGATION_MENUS.MAIL_ROOM_MENU.key, NAVIGATION_MENUS.MAIL_ROOM_MENU.value)}
                    <div className="arrow" />
                  </div>
                )}
              {isFeatureEnabled('Manage Business Data', userDetails) && checkUserAccessRoles(['DESIGNER', 'PUBLISHER', 'REUSABLECONTENTMANAGER']) && (
                  <div
                    className="option"
                    onMouseOver={() => {
                      setSubNav(true);
                      setSubNavAnimate(false);
                      setTimeout(() => {
                        setSubNavAnimate(true);
                      }, 20);
                      setSubNavList([
                        {
                          title: t(
                            NAVIGATION_MENUS.MANAGE_DATA_VARIABLES_MENU.key,
                            NAVIGATION_MENUS.MANAGE_DATA_VARIABLES_MENU.value,
                          ),
                          redirectTo: '/manageVariables',
                          desc: t(
                            NAVIGATION_MENUS.MANAGE_DATA_VARIABLES_MENU_DESCRIPTION.key,
                            NAVIGATION_MENUS.MANAGE_DATA_VARIABLES_MENU_DESCRIPTION.value,
                          ),
                        },
                        {
                          title: t(
                            NAVIGATION_MENUS.MANAGE_BUSINESS_CONTRACTS_MENU.key,
                            NAVIGATION_MENUS.MANAGE_BUSINESS_CONTRACTS_MENU.value,
                          ),
                          redirectTo: '/contracts',
                          desc: t(
                            NAVIGATION_MENUS.MANAGE_BUSINESS_CONTRACTS_MENU_DESCRIPTION.key,
                            NAVIGATION_MENUS.MANAGE_BUSINESS_CONTRACTS_MENU_DESCRIPTION.value,
                          ),
                        },
                      ]);
                    }}
                  >
                    {t(
                      NAVIGATION_MENUS.MANAGE_BUSINESS_DATA_MENU.key,
                      NAVIGATION_MENUS.MANAGE_BUSINESS_DATA_MENU.value,
                    )}
                    <div className="arrow" />
                  </div>
                )}
              {isFeatureEnabled('Cleanup Storage', userDetails) && checkUserAccessRoles(['ADMIN', 'DESIGNER', 'PUBLISHER']) && <div
                  className="option variables"
                  onMouseOver={() => {
                    setSubNav(false);
                  }}
                  onClick={() => redirectTo('/generatedDocuments')}
                >
                  {t(
                    NAVIGATION_MENUS.CLEAN_UP_STORAGE_MENU.key,
                    NAVIGATION_MENUS.CLEAN_UP_STORAGE_MENU.value,
                  )}
                  <div className="arrow" />
                </div>}
              {ENTERPRISE_ENV && isFeatureEnabled('Workflow', userDetails) &&
                checkUserAccessRoles(['WORKFLOW']) &&
                !!licenseDetails?.workFlowUrl ? (
                  <div
                    className="option"
                    onMouseOver={() => {
                      setSubNav(false);
                    }}
                    onClick={navigateToWorkflow}
                  >
                    {t(NAVIGATION_MENUS.WORKFLOW_MENU.key, NAVIGATION_MENUS.WORKFLOW_MENU.value)}
                    <div className="arrow" />
                  </div>
                ) : null}
              {planMapping?.planName !== 'Free' && (
                 <div
                   className="option"
                   onMouseOver={() => {
                     setSubNav(false);
                   }}
                   onClick={() => redirectTo('/support')}
                 >
                   {t(NAVIGATION_MENUS.SUPPORT_MENU.key, NAVIGATION_MENUS.SUPPORT_MENU.value)}
                   <div className="arrow" />
                 </div>
               )}
                <div
                  className="option"
                  onMouseOver={() => {
                    setSubNav(false);
                  }}
                  onClick={togglePasswordModal}
                >
                  {t(
                    NAVIGATION_MENUS.CHANGE_PASSWORD_MENU.key,
                    NAVIGATION_MENUS.CHANGE_PASSWORD_MENU.value,
                  )}
                  <div className="arrow" />
                </div>
              </>
            )}
              <div
                className="option"
                onMouseOver={() => {
                  setSubNav(false);
                }}
                onClick={logOutUser}
              >
                {t(NAVIGATION_MENUS.LOGOUT_MENU.key, NAVIGATION_MENUS.LOGOUT_MENU.value)}
                <div className="arrow" />
              </div>
          </div>
        </div>
        <div
          className={subNav ? 'menus SubNav fade' : !subNav ? 'menus SubNav slide-left-delay' : ''}
        >
          <div className={subNav ? 'Layer slide-right' : !subNav ? 'Layer slide-left' : ''}></div>
          {subNavList.map((item, index) => {
            return (
              <>
                <div
                  className="subMenuOption"
                  key={index}
                  onClick={() => {
                    item.showBillingModal && setShowBillingModal(true)
                    item.isOrganizationSignedIn && exitOrganization()
                    setSubNav(false);
                    item.redirectTo && redirectTo(item.redirectTo);
                  }}
                >
                  <span>{item.title}</span> <div className="arrow" />
                </div>
                <p className="Description">{item.desc}</p>
              </>
            );
          })}
        </div>
      </MenuDrawer>
      <NavGridContainer>
        <GridItemContainer>
          <Link to={'/'}>
            <AppLogo>
              <DocStudioNavLogo />
            </AppLogo>
          </Link>
          { /* These tooltips will be displayed when the app tour is skipped on the landing page */ }
          {tourSkipped ? 
            <CustomTooltip title={t(NAVIGATION_MENUS.MENU_TOOLTIP_TEXT.key, NAVIGATION_MENUS.MENU_TOOLTIP_TEXT.value)} purpleColor sideNav>
              <SideNavButton drawVisible={drawVisible} showDraw={showDraw} hideDraw={hideDraw} />
            </CustomTooltip> 
          : <SideNavButton drawVisible={drawVisible} showDraw={showDraw} hideDraw={hideDraw} />}
          { /* Tooltip for Zoho Support widget */ }
          {tourSkipped && document.getElementById('pdsSupportWidget') && <CustomTooltip title={t(NAVIGATION_MENUS.SUPPORT_TOOLTIP_TEXT.key, NAVIGATION_MENUS.SUPPORT_TOOLTIP_TEXT.value)} widget sideNav /> }
          <div className="copy_right">
            <div style={{fontFamily:'Open Sans',fontWeight:'500'}}> © {APP_VERSION}</div>
            <div className="company">Perfect Doc Studio</div>
          </div>
        </GridItemContainer>
        {ssoSetup?.brandingEnabled && (
          <div className="patnerLogo">
            <div className="logo_1">
              <ImageWithFallback src="client-logo.png" className="image" />
            </div>
            <div className="logo">              
              <ImageWithFallback src="partner-logo.png" className="image" />
            </div>
          </div>
        )}
      </NavGridContainer>
      {modalVisibility && (
        <MultipleFileUploadModal
          visible={modalVisibility}
          onCancel={() => setmodalVisibility(false)}
        />
      )}
      <LogOutModal visible={ModalVisibility} OnCancel={() => setModalVisibility(false)} />
      {openPassword && <ChangePasswordModal visible={openPassword} onCancel={() => setOpenPassword(false)}/>}
      {showBillingModal && (
        <BillingPassword
          visible={showBillingModal}
          onCancel={() => setShowBillingModal(false)}
          isBillingModule={true}
        />
      )}
    </TopNavContainer>
  );
};
export default withTranslation(NAMESPACES)(SideNav);
